import { ModelBase } from "@shoothill/core";
import { ArrayNotEmpty, IsEmail, IsNotEmpty, ValidateIf } from "class-validator";
import { observable } from "mobx";

export class IssueModel extends ModelBase<IssueModel> {
    // #region Defaults

    public static readonly DEFAULT_ISSUEITEMS = [];
    public static readonly DEFAULT_TOEMAILADDRESS = [];
    public static readonly DEFAULT_CCEMAILADDRESS = [];

    // #endregion Defaults

    // #region Properties

    // @observable
    // @ArrayNotEmpty({ message: "You must select at least one RDDV2" })
    // public issueItems = observable<string>(IssueModel.DEFAULT_ISSUEITEMS);

    @observable
    @IsNotEmpty({ message: "You must select To user(s)" })
    public selectedToProjectDirectoryPersonUsers: string[] = IssueModel.DEFAULT_TOEMAILADDRESS;

    @observable
    @IsNotEmpty({ message: "You must select CC user(s)" })
    public selectedCCProjectDirectoryPersonUsers: string[] = IssueModel.DEFAULT_CCEMAILADDRESS;

    // #endregion Properties

    // #region Methods

    fromDto(model: any): void {
        throw new Error("Method not implemented.");
    }

    public toDto(): any {
        return {
            toProjectDirectoryPersonIds: this.selectedToProjectDirectoryPersonUsers === IssueModel.DEFAULT_TOEMAILADDRESS ? null : this.selectedToProjectDirectoryPersonUsers,
            ccProjectDirectoryPersonIds: this.selectedCCProjectDirectoryPersonUsers === IssueModel.DEFAULT_CCEMAILADDRESS ? null : this.selectedCCProjectDirectoryPersonUsers,
        };
    }

    // #endregion Methods
}
